/**
 * @generated SignedSource<<627e46af95af6c7d0540015be4ec2a64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SiteNavDropdownContent_navigationModule$data = {
  readonly imageUrl: string | null;
  readonly items: ReadonlyArray<{
    readonly column: string | null;
    readonly items: ReadonlyArray<{
      readonly linkData: {
        readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
      };
      readonly name: string | null;
    } | null> | null;
    readonly name: string | null;
  } | null> | null;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SiteNavDropdownImageModule_navigationModule">;
  readonly " $fragmentType": "SiteNavDropdownContent_navigationModule";
};
export type SiteNavDropdownContent_navigationModule$key = {
  readonly " $data"?: SiteNavDropdownContent_navigationModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SiteNavDropdownContent_navigationModule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SiteNavDropdownContent_navigationModule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NavigationTopLevel",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "column",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NavigationItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "linkData",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SeoLink_linkData"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SiteNavDropdownImageModule_navigationModule"
    }
  ],
  "type": "NavigationModule",
  "abstractKey": null
};
})();

(node as any).hash = "29cf467b177d1c4a3decf224806f52f9";

export default node;
